//styles
import {
  AssistanceSection,
  AssistanceInner,
  AssistanceTitle,
  AssistanceGrid,
  AssistanceCard,
  AssistanceCardTitle,
  AssistanceCardText,
} from './NeedAssistance.styles';

export function NeedAssistance() {
  return (
    <AssistanceSection>
      <AssistanceInner>
        <AssistanceTitle>Need assistance?</AssistanceTitle>
        <AssistanceGrid>
          <AssistanceCard>
            <AssistanceCardTitle>Haul with Loadsmart</AssistanceCardTitle>
            <AssistanceCardText>carriersales@loadsmart.com</AssistanceCardText>
            <AssistanceCardText>(646) 887 6278</AssistanceCardText>
          </AssistanceCard>
          <AssistanceCard>
            <AssistanceCardTitle>Haul for Loadsmart</AssistanceCardTitle>
            <AssistanceCardText>sales@loadsmart.com</AssistanceCardText>
            <AssistanceCardText>(646) 887 6278</AssistanceCardText>
          </AssistanceCard>
        </AssistanceGrid>
      </AssistanceInner>
    </AssistanceSection>
  );
}
